<template>
    <div style="max-width: 600px;">
        <h2>Экспорт заказов компаний партнеров</h2>
        <small class="text-danger">Пока только ТО! Не меняются реквизиты с ПЭК!</small>
        <div class="d-block my-4">
            <form class="needs-validation" novalidate id="exportPartnerInformationForm">
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label>Партнер</label>
                        <tsoft-select-of-properties
                            :reference_id="4"
                            :needNullElement="false"
                            :selected="params.reference_sources_id"
                            :excludeArray="[
                              895
                            ]"
                            @set="setSourceForExport"
                        ></tsoft-select-of-properties>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="params_date_from">От даты</label>
                        <input v-model="params.date.from" required type="date" class="form-control" id="params_date_from">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="params_date_to">До даты</label>
                        <input v-model="params.date.to" required type="date" class="form-control" id="params_date_to">
                    </div>
                </div>
            </form>
            <div class="form-row mt-3" style="max-width: 600px;">
                <div class="form-group col-md-12 text-center">
                    <button class="btn btn-primary" @click="submitForm($event)">Сформировать <i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></button>
                </div>
            </div>

        </div>

        <div class="d-block" v-if="link != ''">
            <div>
                <b-jumbotron header="Отчет готов!" lead="Система сформировала отчета по указанному партнеру.">
                    <p>Скачать можно по ссылке ниже.</p>
                    <b-button variant="primary" :href="link" target="_blank">Скачать отчет</b-button>
                </b-jumbotron>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        API_POST_WORD_DOC_EXPORT_PARTNERS,
        HOST_FOR_STORAGE
    } from '../constants'

    import {
        motivationWorkWithDates
    } from '../mixins/motivation/motivationHelpers'

    export default {
        mixins: [
            motivationWorkWithDates
        ],
        data() {
            return {
                api: API_POST_WORD_DOC_EXPORT_PARTNERS,
                link: '',
                params: {
                    reference_sources_id: 24,
                    date: {
                        from: '',
                        to: '',
                    },
                    reference_service_ids: [22]
                },
                savingProcess: false,
                hfs: HOST_FOR_STORAGE
            }
        },
        mounted() {
        },
        methods: {
            submitForm(event) {
                event.preventDefault()
                let form = document.getElementById("exportPartnerInformationForm")
                if (form.checkValidity() === false) {
                    event.preventDefault()
                    event.stopPropagation()
                    form.classList.add('was-validated')
                    return false
                }
                this.createNewExport()
            },
            createNewExport(){
                this.savingProcess = true
                this.link = ''

                api.call('post', `${this.api}`, this.params).then(({data}) => {
                    this.link = data
                    this.savingProcess = false
                })
            },
            setSourceForExport(value) {
                this.params.reference_sources_id = value
            },
        }
    }
</script>
